import { ReactNode } from 'react';
import { Popover } from './ui/Popover';
import { Button, Text } from './ui';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import { useTranslation } from 'react-i18next';

interface ConfirmContentProps {
  title: string;
  description: string;
  onConfirm: () => void;
  variant?: 'primary' | 'danger';
  confirmLabel: string;
}

function ConfirmContent({
  title,
  description,
  onConfirm,
  variant = 'primary',
  confirmLabel,
}: ConfirmContentProps) {
  const { t } = useTranslation();

  return (
    <div className="w-13xl">
      <Text strong>{title}</Text>
      <Text>{description}</Text>
      <footer className="mt-sm gap-2xs flex">
        <PopoverPrimitive.Close asChild>
          <Button type="button" variant="secondary" size="sm">
            {t('common.cancel')}
          </Button>
        </PopoverPrimitive.Close>
        <PopoverPrimitive.Close asChild>
          <Button type="button" variant={variant} size="sm" onClick={onConfirm}>
            {confirmLabel || t('common.confirm')}
          </Button>
        </PopoverPrimitive.Close>
      </footer>
    </div>
  );
}

interface PopconfirmProps extends ConfirmContentProps {
  children: ReactNode;
}

export function Popconfirm({ children, ...props }: PopconfirmProps) {
  return <Popover content={<ConfirmContent {...props} />}>{children}</Popover>;
}
